export default "__VITE_ASSET__a95d5675__"